import React from 'react';
import {Segment, Header, Button} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';

const HealthArticlesView = (props) => {
    return (
        <div>
            <Header as='h2' attached='top' block>
                View article
            </Header>
            <Link to="/app/healtharticles">
                <Button attached>
                    Go back to article listing
                </Button>
            </Link>
            <Segment attached>
                <p dangerouslySetInnerHTML={{__html: props.article.content}} />
            </Segment>
        </div>
    );
}

export default HealthArticlesView;